// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-body.central[data-v-41cf61c4] {
  padding: 0 16px 18px 16px;
}
.main-body.central[data-v-41cf61c4] .main-content-container {
  margin: 20px auto 0 auto;
  flex-basis: auto !important;
  background-color: var(--content-container-bgcolor);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0, rgba(0, 0, 0, 0.15) 0 1px 3px 1px;
}
.main-body.central[data-v-41cf61c4] .main-content-container .main-content-container-header {
  margin-bottom: 0px;
  padding-top: 12px;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
}
.main-body.central[data-v-41cf61c4] .main-content-container .main-content-container-main {
  background: inherit;
  box-shadow: none;
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/body/MainContentAcs.vue"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,kDAAkD;EAClD,kBAAkB;EAClB,6EAA6E;AAC/E;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".main-body.central[data-v-41cf61c4] {\n  padding: 0 16px 18px 16px;\n}\n.main-body.central[data-v-41cf61c4] .main-content-container {\n  margin: 20px auto 0 auto;\n  flex-basis: auto !important;\n  background-color: var(--content-container-bgcolor);\n  border-radius: 4px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0, rgba(0, 0, 0, 0.15) 0 1px 3px 1px;\n}\n.main-body.central[data-v-41cf61c4] .main-content-container .main-content-container-header {\n  margin-bottom: 0px;\n  padding-top: 12px;\n  padding-left: 12px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.main-body.central[data-v-41cf61c4] .main-content-container .main-content-container-main {\n  background: inherit;\n  box-shadow: none;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
